(() => {
  /**
   * Impulse + Globo (HulkApps)
   * Goal: Keep MAIN product clickable, but disable click on ADD-ON line items
   * identified by presence of the hidden "Edit Options" button (.edit_cart_option)
   */

  const ADDON_MARKER_SELECTOR = ".edit_cart_option"; // present on Globo add-on line items
  const LINE_ITEM_SELECTOR = ".cart__item";          // Impulse line item wrapper
  const TITLE_LINK_SELECTOR = ".cart__item-title a.cart__item-name";
  const IMAGE_LINK_SELECTORS = [
    ".cart__image a",
    ".cart__item-image a",
    ".cart__item-media a",
    ".cart__item__media a"
  ].join(",");

  function disableAddonLinks(root = document) {
    const items = root.querySelectorAll(LINE_ITEM_SELECTOR);

    items.forEach(item => {
      // Only target Globo add-on line items
      if (!item.querySelector(ADDON_MARKER_SELECTOR)) return;

      // Disable title link
      const titleLink = item.querySelector(TITLE_LINK_SELECTOR);
      if (titleLink) {
        titleLink.dataset.addonNoLink = "1";
        titleLink.removeAttribute("href");
        titleLink.style.cursor = "default";
        titleLink.style.textDecoration = "none";
        titleLink.style.color = "inherit";
      }

      // (Optional) disable image link for add-on item too
      item.querySelectorAll(IMAGE_LINK_SELECTORS).forEach(a => {
        a.dataset.addonNoLink = "1";
        a.removeAttribute("href");
        a.style.cursor = "default";
      });
    });
  }

  // Block any click on disabled add-on links (extra safety)
  document.addEventListener("click", (e) => {
    const a = e.target.closest("a");
    if (!a) return;
    if (a.dataset.addonNoLink === "1") {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
  }, true);

  // Initial run + on DOM ready
  disableAddonLinks();
  document.addEventListener("DOMContentLoaded", () => disableAddonLinks());

  // Re-apply on AJAX updates (quantity changes, cart refresh, drawer, etc.)
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) disableAddonLinks(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
